import app from '@/lib/core' // bootstrapping core app

//
// You can customize/inject code in app here
//

export default app
